import React, { Component } from "react";
import MainMenu from "./components/mainMenu";

export default class Suits extends Component {
  render() {
    return (
      <div>
        <MainMenu initClassName="" /> Our Suits{" "}
      </div>
    );
  }
}
